import React from 'react'
import { Dropdown } from 'react-bootstrap'

function StatusDropDown({ options, onSelect, selectedOption }) {
console.log(selectedOption,"selectedOption");
    return (
        <Dropdown onSelect={onSelect} drop="down-centered" className='table-status-dropdown'>
            <Dropdown.Toggle variant="success" id="dropdown-basic" 
            // className='pending-toggle'
                // {`${selectedOption==="Active" ? "resolved-toggle" 
                // : selectedOption==="InActive " ? "" 
                // : selectedOption==="Pending" ? "pending-toggle" 
                // : selectedOption==="Decline" ? "pending-toggle" 
                // : ''  }`}
            >
                {selectedOption || 'Select Status'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item eventKey="">All</Dropdown.Item>
                {options.map((option, index) => (
                    <Dropdown.Item key={index} eventKey={option}>
                        {option}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default StatusDropDown
